export class Associate {
    isSSOGuardian: boolean;

    constructor(typeId: number, mId){
        this.associateTypeId = typeId;
        this.memberId = mId;
    }

    associateId: number;
    memberId: number;
    associateTypeId: number;
    firstName: string;
    lastName: string;
    dob: Date;
    email: string;
    createdDate: Date;
    lastUpdate: Date;
}


// WEBPACK FOOTER //
// ./src/app/_models/associate.model.ts